// CONTEXT PARA OBTENER INFORMACION DE LA DOCUMENTACION DEL CASO

import { createContext } from "react";

export const DocsContext = createContext();
export const UserContext = createContext();
export const ClientContext = createContext();
export const NotificationContext = createContext();
export const PermissionContext = createContext(null);
